import { handleModalAfterRequest } from '@/stores/modal/utils';

import type { HTMXEvent } from '../types';
import { loadingHandler } from './handlers/loading';

export function htmxAfterRequestHandler(event: HTMXEvent) {
    loadingHandler(event);
    handleModalAfterRequest(event.target.dataset.targetmodal);
}

document.addEventListener('htmx:afterRequest', htmxAfterRequestHandler);
